import {createAction} from "@ngrx/store";

export class NavigationActions {
	static readonly GO_TO_ACCOUNT_SETTINGS = createAction('GO_TO_ACCOUNT_SETTINGS');
	static readonly GO_TO_SESSION_EXPIRED_PAGE = createAction('GO_TO_SESSION_EXPIRED_PAGE');
	static readonly GO_TO_ADMIN_PANEL = createAction('GO_TO_ADMIN_PANEL');
	static readonly GO_TO_LOGIN_PAGE = createAction('GO_TO_LOGIN_PAGE');
	static readonly GO_TO_ERROR_PAGE = createAction('GO_TO_ERROR_PAGE');
	static readonly GO_TO_KPIS = createAction('GO_TO_KPIS');
	static readonly GO_TO_USER_MGMT = createAction('GO_TO_USER_MGMT');
	static readonly GO_TO_CONFIG_PANEL = createAction('GO_TO_CONFIG_PANEL');

}
